export const NEW_LINE_REGEX = /\r?\n|\\n/;
